export default (function getFormatOptions(formatOptions) {
  let options = {};
  if (formatOptions && formatOptions.length > 0) {
    formatOptions.forEach(option => {
      options[option.name] = option.selected;
    });
  }
  return options;
});